const message_types = {
  error: 'error',
  info: 'info',
  warning: 'warning',
};

export default {
  message_types,
};



// WEBPACK FOOTER //
// ./src/app/shared/error-message/constants/message-box-constatns.js